export default function batchFunction (fn, timeoutMs) {
  let waitingMap = {};
  let currentTimeout = null;

  timeoutMs = ~~timeoutMs || 0;

  async function handleBatch () {
    currentTimeout = null;
    const clonedWaitingMap = waitingMap;
    waitingMap = {};

    try {
      const res = await fn(Object.keys(clonedWaitingMap));

      for (const key in clonedWaitingMap) {
        for (const { resolve } of clonedWaitingMap[key]) {
          resolve(res[key]);
        }
      }
    } catch (e) {
      for (const key in clonedWaitingMap) {
        for (const { reject } of clonedWaitingMap[key]) {
          reject(e);
        }
      }
    }
  }

  return function (id) {
    return new Promise((resolve, reject) => {
      if (! waitingMap[id]) {
        waitingMap[id] = [];
      }
      waitingMap[id].push({
        resolve,
        reject,
      });

      if (! currentTimeout) {
        currentTimeout = setTimeout(handleBatch, timeoutMs);
      }
    });
  }
}
